export const TABS_NAVIGATION = {
  CHANGES: 'changes',
  MAINTENANCE: 'maintenance',
  REMOTE_HANDS: 'remote-hands',
};
